import { React, useRef } from "react";

import { EMPTY_STRING } from "../../../constants";
import CategoriesDropdown from "../selectDropdown/CategoriesDropdown";
import {
  categoriesDropdownStyle,
  insertVariableSelectFieldStyle,
  sidebarSelectFieldStyle,
} from "../../../assets/scss/style";

const TextAreaWithInsertVariable = ({
  value,
  onChange,
  isDisabled = false,
  placeHolder = EMPTY_STRING,
  name = "textareaWithInsertVariable",
  variableOptions = [{ value: "user_name", label: "User Name" }],
}) => {
  const textAreaRef = useRef(null);

  // Inserts a variable at the current cursor position in the textarea
  const insertAtCursor = (insertedVariable) => {
    const textarea = textAreaRef.current;
    if (!textarea) return;

    const { selectionStart, selectionEnd } = textarea;
    const before = value.slice(0, selectionStart);
    const after = value.slice(selectionEnd);

    const newValue = before + insertedVariable + after;

    onChange(newValue);
    const pos = selectionStart + insertedVariable.length;
    textarea.setSelectionRange(pos, pos);
    textarea.focus();
  };

  const handleVariableSelect = (selected) => {
    if (!selected) return;
    const tag = `{{${selected.value}}}`;
    insertAtCursor(tag);
  };

  return (
    <div
      className={
        "d-flex flex-column position-relative input-textarea-with-insert-variable"
      }
    >
      <div className={"header"}>
        <div className="category-dropdowns">
          <CategoriesDropdown
            value={value}
            isStartIcon={false}
            isClearable={false}
            disabled={isDisabled}
            options={variableOptions}
            placeholder={"Insert Variable"}
            handleChange={handleVariableSelect}
            noOptionsMessage={"No variables available"}
            styles={insertVariableSelectFieldStyle}
          />
        </div>
      </div>
      <textarea
        rows={4}
        name={name}
        value={value}
        ref={textAreaRef}
        disabled={isDisabled}
        placeholder={placeHolder}
        onChange={(e) => onChange(e.target.value)}
        className={`input-textfield position-relative w-100`}
      />
    </div>
  );
};

export default TextAreaWithInsertVariable;
